import {
    Button,
    Dialog,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    FormHelperText,
} from '@material-ui/core';
import { useCallback, useEffect } from 'react';
import { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import en from '../../../lang/en-us';
import { SubmitButton } from '../../../lib/Button';
import { getAmcList } from '../../../redux-store/actions/nct';
import { validateTransmission } from '../../../redux-store/actions/nct';
import { AMC_LIST_RESPONSE } from '../../../redux-store/types/nct';
import ToggleTabs, { OFF, ON } from '../../../lib/ToggleTabs';
import { PRE_LOGIN_TRANSMISSION } from '../../../redux-store/types/links';
import { ActionHeader } from '../../dashboard/makeNct';
import { TransmissionFormType } from '.';
const {
    dashboard,
    common,
    signUp: { form },
} = en;

export const NOMINEE = 'Nominee';
export const HOLDER = 'Jointholder';
export const CLAIMANT = 'Claimant';
export interface HolderStateProps extends TransmissionFormType {
    targetFunds: FUNDS_LIST[];
    holderPan: string;
    holderEmail?: string;
    holderMobile?: string;
    amcs: any;
    pans: Array<string>;
    reqId: string;
    addedFolios: any;
    data?: any;
    numDfc: number;
    images?: any;
}
interface TransmissionHolderProps extends RouteComponentProps<any, any, HolderStateProps> {
    getAmcList: () => Promise<{ body: AMC_LIST_RESPONSE[] }>;
    validateTransmission: (body: any) => Promise<any>;
}

type FUNDS_LIST = {
    amc_code: string;
    folio: string;
};

const DefaultFund: FUNDS_LIST = {
    amc_code: '',
    folio: '',
};

type InputTextState = {
    message?: string;
    value: string;
};

type TransmissionState = {
    fund: FUNDS_LIST;
    claimantType: string;
};

function TransmissionRequestHolder(props: TransmissionHolderProps) {
    const [open, setOpen] = useState(true);
    const [proceed, setProceed] = useState(false);
    const [nomineeOpen, setNomineeOpen] = useState(false);
    const [amcList, setAmcList] = useState<AMC_LIST_RESPONSE[]>([]);
    // const [amcCode, setAmcCode] = useState<String>('');

    const { pan, mobile, email, pans, reqId } = props.location.state || {};

    useEffect(() => {
        if (!props.location.state || !pan || !mobile || !email) {
            props.history.replace('/');
        }
    }, []);

    // let { pans }: any = props;

    // let pan: any,
    //     mobile: any,
    //     email: any,
    //     reqId: any = '';

    const handleClose = () => {
        setOpen(false);
    };

    // console.log('th', props);

    useEffect(() => {
        async function callApi() {
            try {
                let { body = [] } = await props.getAmcList();
                body.sort((a: any, b: any) => {
                    if (a.amc_name < b.amc_name) {
                        return -1;
                    }
                    if (a.amc_name > b.amc_name) {
                        return 1;
                    }
                    return 0;
                });
                setAmcList(body);
            } catch (err: any) {
                alert(err.message);
            }
        }
        callApi();
    }, []);
    const [transmission, setTransmission] = useState<TransmissionState>({
        fund: DefaultFund,
        claimantType: '',
    });
    const [addedFolios, setAddedFolios] = useState<TransmissionState[]>([]);
    const [submitEmpty, setSubmitEmpty] = useState<boolean>(false);

    const getNocFromString = (str: string) => {
        let noc = '';
        switch (str) {
            case dashboard.TransmissionRequest.holderDetails.claimValues.value2:
                noc = NOMINEE;
                break;
            case dashboard.TransmissionRequest.holderDetails.claimValues.value3:
                noc = CLAIMANT;
                break;
            case dashboard.TransmissionRequest.holderDetails.claimValues.value1:
                noc = HOLDER;
                break;
            default:
                noc;
        }
        return noc;
    };

    const handleSubmit = async (e: any) => {
        try {
            let { fund, claimantType } = transmission;
            let { amc_code, folio } = fund;
            let data: any = [];
            let deceasedPans: any = {};
            let noc = getNocFromString(claimantType);
            // let noc_res = noc === 'Jointholder' ? 'holder' : noc[0].toLowerCase() + noc.slice(1);
            // let noc_res;
            // if (noc === '') {
            //     noc_res = '';
            // } else if (noc === 'Jointholder') {
            //     noc_res = 'holder';
            // } else {
            //     noc_res = noc[0].toLowerCase() + noc.slice(1);
            // }

            if (
                addedFolios.find(
                    (ele) => ele.fund.amc_code === amc_code && ele.fund.folio === folio,
                )
            ) {
                throw new Error('Folio already added');
            }
            pans.forEach((pan: string, index: number) => {
                let key = `deceasedPan${index + 1}`;
                if (!!pan) {
                    deceasedPans[key] = pan.toUpperCase();
                }
            });
            addedFolios.forEach((ele) => {
                let noc = getNocFromString(ele.claimantType);
                data.push({
                    amc: ele.fund.amc_code,
                    folio: ele.fund.folio,
                    natureOfClaimant: noc,
                    ...deceasedPans,
                });
            });
            // If every field is empty and one added folio
            if (addedFolios.length >= 1 && claimantType === '' && amc_code === '' && folio === '') {
                props.history.replace('/links/transmission-download-list', {
                    ...props.location.state,
                    amcs: resFolios.current,
                    data,
                });
                return;
            }
            if (
                addedFolios.length < 1 &&
                !(
                    transmission.claimantType &&
                    transmission.fund.amc_code &&
                    transmission.fund.folio
                )
            ) {
                setSubmitEmpty(true);
                return;
            }

            let body: any = {
                amc: amc_code,
                folio,
                natureOfClaimant: noc,
                reqId,
                claimantPan: pan,
                action: PRE_LOGIN_TRANSMISSION,
            };
            pans.forEach((pan: string, index: number) => {
                body[`pan${index + 1}`] = pan.toUpperCase();
            });
            let res = await props.validateTransmission(body);

            let tempFolio = {
                ...res.body.success[0],
                amc: getAmcString(res.body.success[0].amc),
                noc,
            };
            resFolios.current = [...resFolios.current, tempFolio];
            data.push({
                amc: transmission.fund.amc_code,
                folio: transmission.fund.folio,
                natureOfClaimant: getNocFromString(transmission.claimantType),
                ...deceasedPans,
            });
            props.history.replace('/links/transmission-download-list', {
                ...props.location.state,
                amcs: resFolios.current,
                data,
            });
        } catch (err: any) {
            alert(err.message);
            // setSubmitEmpty(true);
            setTransmission({
                fund: DefaultFund,
                claimantType: '',
            });
        }
    };

    const resFolios = useRef<any[]>([]);

    const handleAddFolio = async () => {
        try {
            let { fund, claimantType } = transmission;
            let { amc_code, folio } = fund;
            if (claimantType === '' || amc_code === '' || folio === '') {
                setSubmitEmpty(true);
                return;
            }
            if (
                addedFolios.find(
                    (ele) => ele.fund.amc_code === amc_code && ele.fund.folio === folio,
                )
            ) {
                alert('Folio already added');
                return;
            }
            let noc = getNocFromString(claimantType);
            let body: any = {
                amc: amc_code,
                folio,
                natureOfClaimant: noc,
                reqId,
                claimantPan: pan,
                action: PRE_LOGIN_TRANSMISSION,
            };
            pans.forEach((pan: string, index: number) => {
                body[`pan${index + 1}`] = pan.toUpperCase();
            });
            let res = await props.validateTransmission(body);
            // let noc_res = noc === 'Jointholder' ? 'holder' : noc.toLowerCase();

            let tempFolio = {
                ...res.body.success[0],
                amc: getAmcString(res.body.success[0].amc),
                noc: noc,
            };
            resFolios.current = [...resFolios.current, tempFolio];

            setAddedFolios((prevState) => {
                return [...prevState, transmission];
            });
        } catch (err: any) {
            alert(err.message);
            setSubmitEmpty(true);
        } finally {
            setTransmission({
                fund: DefaultFund,
                claimantType: '',
            });
        }
    };

    const handleDeleteFolio = (index: number) => {
        setAddedFolios((prevState) => {
            return [...prevState.slice(0, index), ...prevState.slice(index + 1)];
        });
        resFolios.current = [
            ...resFolios.current.slice(0, index),
            ...resFolios.current.slice(index + 1),
        ];
    };

    const getAmcString = (amc: string) => {
        try {
            return amcList.filter((ele) => {
                if (ele.amc_code == amc) {
                    return ele.amc_name;
                }
            })[0].amc_name;
        } catch (err) {
            return 'NONE';
        }
    };

    const AddedFolio = ({ noc, amcCode, folio, index, ...props }: any) => {
        let amcValue = getAmcString(amcCode);
        return (
            <div className="transmission-basic-detail-form added-folio">
                <div>
                    <p>
                        {dashboard.TransmissionRequest.holderDetails.addedFolio.fund}
                        <span> {amcValue} </span>
                    </p>
                    <p>
                        {dashboard.TransmissionRequest.holderDetails.addedFolio.folio}
                        <span> {folio}</span>
                    </p>
                    <p>
                        {dashboard.TransmissionRequest.holderDetails.addedFolio.natureClaim}
                        <span>{noc}</span>
                    </p>
                </div>
                <a
                    onClick={() => {
                        handleDeleteFolio(index);
                    }}
                >
                    <img
                        className="delete-details-icon"
                        src="/images/delete-folio.svg"
                        alt="icon"
                    />
                </a>
            </div>
        );
    };

    return (
        <div className="curved-bg">
            {/* <ActionHeader header={dashboard.TransmissionRequest.TransmissionUnitHeading} /> */}
            <h2 className="heading">
                <a onClick={() => props.history.goBack()}>
                    <img src="/images/left-arrow-black.svg" alt="icon" />
                </a>
                {dashboard.TransmissionRequest.TransmissionUnitHeading}
            </h2>
            <div className="curved-bg-content transmission-request transmission-holder-details">
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <div className="transmission-basic-details transmission-details-claim">
                            <p>
                                {dashboard.TransmissionRequest.holderDetails.primaryHolderDetails}
                            </p>
                            {addedFolios.map(({ fund, claimantType }, index) => {
                                return (
                                    <AddedFolio
                                        index={index}
                                        noc={claimantType}
                                        folio={fund.folio}
                                        amcCode={fund.amc_code}
                                    />
                                );
                            })}
                            {/*  */}
                            <div
                                className="transmission-basic-detail-form transmission-nature-claim"
                                style={{ borderBottom: 0 }}
                            >
                                <>
                                    <FormControl variant="outlined">
                                        <InputLabel id="transmission-amc-label">
                                            {dashboard.TransmissionRequest.holderDetails.selectAmc}
                                        </InputLabel>
                                        <Select
                                            labelId="transmission-amc-label"
                                            id="transmission-amc"
                                            label="Age"
                                            value={transmission.fund.amc_code}
                                            error={submitEmpty && !transmission.fund.amc_code}
                                            onChange={(e: any) => {
                                                // if (index == addedFolios.length - 1)
                                                setTransmission((prevState) => {
                                                    return {
                                                        ...prevState,
                                                        fund: {
                                                            ...prevState.fund,
                                                            amc_code: e.target.value,
                                                        },
                                                    };
                                                });
                                                if (submitEmpty) {
                                                    setSubmitEmpty(false);
                                                }
                                                // setAmcCode(transmission.fund.amc_code);
                                            }}
                                        >
                                            {amcList.map((ele) => (
                                                <MenuItem key={ele.amc_code} value={ele.amc_code}>
                                                    {ele.amc_name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {submitEmpty && !transmission.fund.amc_code ? (
                                            <FormHelperText error={true}>
                                                {' '}
                                                Please select Fundhouse
                                            </FormHelperText>
                                        ) : null}
                                    </FormControl>
                                    <div
                                        className="enter-folio-input"
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <TextField
                                            variant="outlined"
                                            label={
                                                dashboard.TransmissionRequest.holderDetails
                                                    .enterFolio
                                            }
                                            value={transmission.fund.folio}
                                            onChange={(e: any) => {
                                                setTransmission((prevState) => {
                                                    if (
                                                        !/^\d+$/.test(e.target.value) &&
                                                        !!e.target.value
                                                    )
                                                        return prevState;
                                                    return {
                                                        ...prevState,
                                                        fund: {
                                                            ...prevState.fund,
                                                            folio: e.target.value,
                                                        },
                                                    };
                                                });
                                                if (submitEmpty) {
                                                    setSubmitEmpty(false);
                                                }
                                            }}
                                            error={submitEmpty && !transmission.fund.folio}
                                            helperText={
                                                submitEmpty && !transmission.fund.folio
                                                    ? 'Please enter a folio'
                                                    : null
                                            }
                                        />
                                    </div>
                                    <FormControl variant="outlined" style={{ marginRight: 0 }}>
                                        <InputLabel id="transmission-amc-label">
                                            {
                                                dashboard.TransmissionRequest.holderDetails
                                                    .natureOfClaim
                                            }
                                        </InputLabel>
                                        <Select
                                            labelId="transmission-amc-label"
                                            id="transmission-amc"
                                            label="Age"
                                            value={transmission.claimantType}
                                            error={submitEmpty && !transmission.claimantType}
                                            onChange={(e: any) => {
                                                setTransmission((prevState) => {
                                                    return {
                                                        ...prevState,
                                                        claimantType: e.target.value,
                                                    };
                                                });
                                                if (
                                                    e.target.value ===
                                                    dashboard.TransmissionRequest.holderDetails
                                                        .claimValues.value2 ||
                                                    e.target.value ===
                                                    dashboard.TransmissionRequest.holderDetails
                                                        .claimValues.value1
                                                ) {
                                                    setNomineeOpen(true);
                                                }
                                                if (submitEmpty) {
                                                    setSubmitEmpty(false);
                                                }
                                            }}
                                        >
                                            <MenuItem
                                                value={
                                                    dashboard.TransmissionRequest.holderDetails
                                                        .claimValues.value1
                                                }
                                            >
                                                {
                                                    dashboard.TransmissionRequest.holderDetails
                                                        .claimValues.value1
                                                }
                                            </MenuItem>
                                            <MenuItem
                                                value={
                                                    dashboard.TransmissionRequest.holderDetails
                                                        .claimValues.value2
                                                }
                                            >
                                                {
                                                    dashboard.TransmissionRequest.holderDetails
                                                        .claimValues.value2
                                                }
                                            </MenuItem>
                                            <MenuItem
                                                value={
                                                    dashboard.TransmissionRequest.holderDetails
                                                        .claimValues.value3
                                                }
                                            >
                                                {
                                                    dashboard.TransmissionRequest.holderDetails
                                                        .claimValues.value3
                                                }
                                            </MenuItem>
                                        </Select>
                                        {submitEmpty && !transmission.claimantType ? (
                                            <FormHelperText error={true}>
                                                {' '}
                                                Please select Nature of Claimant
                                            </FormHelperText>
                                        ) : null}
                                    </FormControl>
                                </>
                            </div>
                            <div className="add-folio">
                                <a onClick={handleAddFolio}>
                                    <img src="/images/add-purple.svg" alt="icon" />
                                    {dashboard.TransmissionRequest.holderDetails.addFolio}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButton
                            onClick={handleSubmit}
                            label={dashboard.changeEmail.buttonText}
                            disabled={
                                addedFolios.length < 1 &&
                                !transmission.claimantType &&
                                !transmission.fund.amc_code &&
                                !transmission.fund.folio
                            }
                            className="customBtn"
                        />
                    </div>
                </div>
            </div>
            <Dialog
                onClose={handleClose}
                maxWidth={'sm'}
                open={open}
                aria-labelledby="transmission-main-modal"
            >
                <div className="note-modals transmission-main-modal">
                    <h3>{dashboard.TransmissionRequest.holderDetails.modal.heading}</h3>
                    <p>{dashboard.TransmissionRequest.holderDetails.modal.info}</p>
                    <div className="note-modals-btns">
                        <Button className="customBtn" onClick={handleClose}>
                            {dashboard.TransmissionRequest.holderDetails.modal.okay}
                        </Button>
                    </div>
                </div>
            </Dialog>
            <Dialog
                onClose={() => setNomineeOpen(false)}
                maxWidth={'xs'}
                open={nomineeOpen}
                aria-labelledby="transmission-main-modal"
            >
                <div className="note-modals transmission-main-modal">
                    <h3>{dashboard.TransmissionRequest.holderDetails.modal.heading}</h3>
                    <p>
                        {' '}
                        {transmission.claimantType ===
                            dashboard.TransmissionRequest.holderDetails.claimValues.value2
                            ? dashboard.TransmissionRequest.holderDetails.nomineeModal.info
                            : dashboard.TransmissionRequest.holderDetails.holderModal.info}
                    </p>
                    <div className="note-modals-btns">
                        <Button className="customBtn" onClick={() => setNomineeOpen(false)}>
                            {dashboard.TransmissionRequest.holderDetails.modal.okay}
                        </Button>
                    </div>
                </div>
            </Dialog>
            <Dialog
                onClose={() => setProceed(false)}
                maxWidth={'sm'}
                open={proceed}
                aria-labelledby="transmission-main-modal"
            >
                <div className="note-modals transmission-main-modal">
                    <h3>{dashboard.TransmissionRequest.holderDetails.modal2.heading}</h3>
                    <p>{dashboard.TransmissionRequest.holderDetails.modal2.info}</p>
                    <div className="note-modals-btns">
                        <Button className="customBtn cancelBtn" onClick={() => setProceed(false)}>
                            {dashboard.TransmissionRequest.holderDetails.modal2.cancel}
                        </Button>
                        <Button className="customBtn" onClick={handleSubmit}>
                            {dashboard.TransmissionRequest.holderDetails.modal2.okay}
                        </Button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default connect(null, { getAmcList, validateTransmission })(TransmissionRequestHolder);
